function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#34CB9E",
  fillRule: "evenodd",
  stroke: "#34CB9E",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.412 14.5c-.32 0-.578.26-.578.578v5.13c-.001.957-.776 1.733-1.733 1.734H2.889c-.957-.001-1.732-.777-1.733-1.734V5.152c0-.957.776-1.732 1.733-1.733h5.13c.32 0 .578-.259.578-.578 0-.319-.259-.578-.578-.578h-5.13C1.294 2.265.002 3.557 0 5.153v15.056c.002 1.594 1.294 2.887 2.889 2.889H19.1c1.595-.002 2.887-1.295 2.889-2.89v-5.13c0-.319-.259-.577-.578-.577z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.76.777C20.746-.24 19.1-.24 18.085.777L7.776 11.085c-.07.07-.122.158-.148.254l-1.356 4.894c-.056.2.001.415.148.563.147.147.362.203.563.148l4.894-1.356c.096-.027.183-.078.254-.148L22.44 5.132c1.014-1.016 1.014-2.661 0-3.677L21.76.777zM9.036 11.46l8.436-8.436 2.72 2.72-8.436 8.437-2.72-2.72zm-.544 1.09l2.174 2.175-3.007.833.833-3.007zm13.13-8.235l-.612.612-2.721-2.72.613-.613c.564-.564 1.479-.564 2.043 0l.678.678c.563.564.563 1.478 0 2.043h0z"
}));

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.463cb1c7.svg";
export { ForwardRef as ReactComponent };